export const MedicinesPermissions = {
    List: 19000,
    Create: 19001,
    Update: 19002,
    ShowDetails: 19003,
    Delete: 19004,
    LockUnLock: 19005,

}
export const PurchaseOrdersPermissions = {
    List: 20000,
    Create: 20001,
    Update: 20002,
    ShowDetails: 20003,
    Delete: 20004,
    ApproveCancel: 20006,


}
export const StockTransfersPermissions = {
    List: 25000,
    Create: 25001,
    Update: 25002,
    ShowDetails: 25003,
    Delete: 25004,
    ApproveCancel: 25006,


}
export const inventoryPermissions = {
    List: 21000,
  

}
export const suppliersPermissions = {
    List: 22000,
    Create: 22001,
    Update: 22002,
    ShowDetails: 22003,
    Delete: 22004,
    LockUnLock: 22005,


}
export const dispenseRequestsPermissions = {
    List: 26000,
    ShowDetails: 26003,
    ApproveCancel: 26006,


}